/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CategoryNew_lists$ref: FragmentReference;
declare export opaque type CategoryNew_lists$fragmentType: CategoryNew_lists$ref;
export type CategoryNew_lists = {|
  +id: string,
  +$refType: CategoryNew_lists$ref,
|};
export type CategoryNew_lists$data = CategoryNew_lists;
export type CategoryNew_lists$key = {
  +$data?: CategoryNew_lists$data,
  +$fragmentRefs: CategoryNew_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CategoryNew_lists",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Lists"
};
// prettier-ignore
(node/*: any*/).hash = 'ef4d676aaf80512ce4187124408c8a22';

module.exports = node;
